// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nk-5";
export var filledCircle = "_nk-4";
export var historyEntry = "_nk-3";
export var messageSideLeft = "_nk-1";
export var messageSideRight = "_nk-2";
export var orderTrackingCarouselWrapper = "_nk-6";
export var orderTrackingInfoContainer = "_nk-0";